<template>
  <div class="bg-ff flex-1">
    <div class="flex mb-10 plr-20 border-b-e2 align-center">
      <div class="title flex align-center mr-20 mtb-10">
        <div class="decoration-line mr-5"></div>
        <div class="font-16-46b8b0 font-bold">{{titleName}}</div>
      </div>
    </div>
    <div class="mtb-10 flex flex-wrap plr-20" v-if="permission.includes('upload')">
      <div class="flex align-center mr-5 mb-5 " :class="Index === 0 ? 'btn-24-bg-46b8b0' : 'btn-24-bd-30313a' " @mouseenter="enter(0)" @mouseleave="leave(0)" >
        <img :src="Index === 0 ? '/static/images/customer/chubeikehu-bai.png' : '/static/images/customer/chubeikehu.png'" class="icon-14 mr-5" alt="">
        <el-upload
          multiple
          name="file"
          :httpRequest="httpRequestImg"
          :action="upload"
          :show-file-list="false"
          :before-upload="beforeImgUpload">
          <div>上传</div>
        </el-upload>
      </div>
    </div>
    <div class="flex flex-wrap  plr-20">
      <div class="mr-10 mb-10 w-377 h-135 bg-f3f4f7 flex" v-for="(item,index) in plan" :key="index">
        <!--<div class="flex align-center justify-center border-r-dashed-e2"><img :src="item.filePath" alt=""  width="135px" height="135px"></div>-->
        <viewer :images="plan" class="flex align-center justify-center border-r-dashed-e2">
          <img :src="item.filePath" alt=""  width="135px" height="135px">
        </viewer>
        <div class="p-20 flex-column text-left w-100">
          <div class="min-h-69">
            <div class="font-12-27 mb-10 word-break">{{item.name}}</div>
            <div class="font-12-b9b9b9" v-if="item.foundName || item.createTime">上传：{{item.foundName}} {{Utils.formatTime2(item.createTime)}}</div>
            <div class="font-12-b9b9b9" v-if="item.examineName || item.examineTime">审核：{{item.examineName}} {{Utils.formatTime2(item.examineTime)}}</div>
          </div>
          <div class="flex align-center mt-10 flex-1">
            <div class="flex-1"><button :class="item.status === 2 ? 'btn-16-bg-82b925-r' : 'btn-16-bd-85-r'">{{item.status === 2 ? '已审核' : '未审核'}}</button></div>
            <div class="flex-1 flex justify-end">
              <img src="/static/images/bianji.png" class="mr-10 icon-14" style="cursor:pointer" alt="" v-if="item.status === 1" @click="editDraw(item.id)">
              <img src="/static/images/xiazai.png" v-if="permission.includes('download')" class="icon-14" style="cursor:pointer" :class="item.status === 1 ? 'mr-10':''" alt="" @click="download(item.filePath)">
              <img src="/static/images/tongguo.png" class="mr-10 icon-14" style="cursor:pointer" alt="" v-if="item.status === 1 && permission.includes('checkFile')" @click="auditDraw(item.id)">
              <img src="/static/images/shanchu.png" class="" alt="" style="width: 12px;height: 14px;cursor:pointer" v-if="item.status === 1 && permission.includes('upload')" @click="deleteDraw(item.id)">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rendering-item',
  props: ['titleName', 'drawingType', 'plan', 'info', 'picId'],
  data () {
    return {
      permission: [],
      Index: -1,
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`
    }
  },
  mounted () {
    this.getPermission()
  },
  methods: {
    getPermission () {
      let list = {
        parent: 'file',
        parentGroup: 'file'
      }
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, list).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    enter (e) {
      this.Index = e
    },
    leave () {
      this.Index = -1
    },
    beforeImgUpload () {},
    httpRequestImg (e) {
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 4)
      formData.append('description', '')
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.axios.post(`${this.$store.state.API_URL_9010}/customerFile/save`, {
            customerId: this.info.id,
            classifyId: this.picId,
            filePath: onloadRes.data.data.path,
            name: e.file.name
          }).then(saveRes => {
            if (saveRes.data.success) {
              this.$parent.$parent.$parent.queryData()
              this.$message({
                type: 'success',
                message: '上传成功！'
              })
            } else {
              this.$message.error('上传失败1！')
            }
          })
        }
      }).catch(() => {
        this.$message.error('上传失败3！')
      })
    },
    deleteDraw (id) {
      this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerFile/deleteById`, this.qs.stringify({
          id: id
        })).then(saveRes => {
          if (saveRes.data.success) {
            this.$message({
              type: 'success',
              message: '删除成功！'
            })
            this.$parent.$parent.$parent.queryData()
          } else {
            this.$message.error('删除失败！')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    editDraw (id) {
      this.$prompt('改为：', '辑编图片名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '名称为空'
      }).then(({ value }) => {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerFile/modify`, {
          id: id,
          name: value
        }).then(saveRes => {
          if (saveRes.data.success) {
            this.$message({
              type: 'success',
              message: '编辑成功！'
            })
            this.$parent.$parent.$parent.queryData()
          } else {
            this.$message.error('编辑失败！')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消编辑'
        })
      })
    },
    auditDraw (id) {
      this.$confirm('是否通过审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerFile/check`, {
          id: id
        }).then(saveRes => {
          if (saveRes.data.success) {
            this.$message({
              type: 'success',
              message: '审核通过！'
            })
            this.$parent.$parent.$parent.queryData()
          } else {
            this.$message.error('审核失败！')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审核'
        })
      })
    },
    downloadIamge (imgsrc, name) {
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png')

        var a = document.createElement('a')
        var event = new MouseEvent('click')
        a.download = name || 'photo'
        a.href = url
        a.dispatchEvent(event)
      }
      image.src = imgsrc
    },
    download (path) {
      // this.downloadIamge(path, 'pic')
      window.open(path)
    }
  }
}
</script>

<style scoped>
  .decoration-line {
    width: 4px;
    height: 16px;
    background-color: #46b8b0;
    border-radius: 4px;
  }
  .w-377{
    width: 377px;
  }
  .w-135{
    width: 135px;
  }
  .h-135{
    height: 135px;
  }
  .min-h-69{
    min-height: 69px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/drawingItem/picItem.vue